export const servicesQueryKeys = {
  getNewAccessToken: ({ refresh_token }: { refresh_token: string }) => [
    'new-access-token',
    refresh_token,
  ],
  getCompany: ({ companyId }: { companyId: string }) => ['company-details', companyId],
};
